<template>
  <div>
    <app-header title="Machine Control" />

    <b-container>
      <b-form-group>
        <label>Device Serial Number</label>
        <b-form-input v-model="assign.device" type="text"></b-form-input>
        <b-button variant="light" @click="detect()">
          Detect (USB)
        </b-button>
      </b-form-group>
      <b-form-group>
        <label>Store ID</label>
        <b-form-input v-model="assign.store_id" type="number"></b-form-input>
      </b-form-group>
      <b-button variant="primary" @click="save()">
        Assign Machine
      </b-button>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
  },

  data() {
    return {
      assign: {},
    };
  },

  methods: {
    async detect() {
      const device = await navigator.usb.requestDevice({
        filters: [],
      });
      this.assign.device = device.serialNumber;
    },

    async save() {
      await $api.post('/v1/internal/machineuse', this.assign);
      alert('Assigned OK'); // eslint-disable-line no-alert
    },
  },
};
</script>
